// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"08a5eaa5","221":"904b1527","341":"afd74fb2","453":"c3ac6373"}[chunkId] + ".chunk.js";
};